import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

// The ruled label/value row shared by EditableField's reviewable fields and the sync modal's
// read-only Selected Facility row — same label width and colors so a read-only row sits flush
// with the editable ones above it. `$divider` is optional because the last row in a list (the
// read-only Selected Facility row) intentionally has no line under it.
export const FieldRow = styled.div<{ $divider?: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  ${({ $divider }) => $divider && `border-bottom: 1px solid ${colors.black10};`}
`;

export const FieldLabel = styled(BodySmall)`
  color: ${colors.black50};
  flex: 0 0 40%;
`;

export const FieldValueCell = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
